import React from "react";
import deskTopStyles from "../../styles/desktopStyles";
import Header from "./Header";

const DeskTop: React.FC = () => {
  return (
    <>
      <style>{deskTopStyles}</style>
      <Header />
    </>
  );
};

export default DeskTop;
